module.exports = __webpack_public_path__ + "img/btn_onestore.c854243f.png";